/**
 * Logbook Model
 *
 * Interfaces for logbook overview API responses.
 *
 * Reference: /agent-os/specs/2026-01-27-logbook-overview-page/spec.md
 */

/**
 * Logbook stats response
 * GET /organizations/:orgId/logbook/stats
 */
export interface LogbookStats {
  totalAcresSprayed: number;
}

/**
 * Logbook report dates response
 * GET /organizations/:orgId/logbook/report-dates
 */
export interface LogbookReportDates {
  faaLastGenerated: string | null;
  stateLastGenerated: string | null;
}
